const envConfig = require('tilby.env.config');
const platformConfig = require('tilby.platform.config');

export type EnvironmentType = "unstable" | "stable" | "beta" | "local";

export interface EnvironmentConfig {
    analyticsUrl: string,
	apiUrl: string,
	clientId: string,
	clientSecret: string,
	environment: EnvironmentType,
	redirectUri: string,
	tilbyLoginUrl: string,
}

export const EnvironmentConfig: EnvironmentConfig = { ...envConfig, ...platformConfig };